import React, { createContext, useState, useContext } from 'react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showSuccess = (message) => {
    setToast({ type: 'success', message });
    hideAfterDelay();
  };

  const showError = (message) => {
    setToast({ type: 'error', message });
    hideAfterDelay();
  };

  const hideAfterDelay = () => {
    setTimeout(() => setToast(null), 3000); // Hide after 3 seconds
  };

  return (
    <ToastContext.Provider value={{ showSuccess, showError }}>
      {children}
      {toast && (
        <div
          className={`alert position-fixed top-0 end-0 m-3 alert-${toast.type === 'success' ? 'success' : 'danger'}`}
          role="alert"
          style={{ zIndex: 9999, minWidth: '300px' }}
        >
          {toast.message}
        </div>
      )}
    </ToastContext.Provider>
  );
};
